import type { TFunction } from 'i18next';

export const getMetricDescription = (
  value: number,
  type: 'precision' | 'recall' | 'f1',
  t: TFunction
) => {
  if (type === 'precision') {
    if (value === 1.0) return t('ALL_RETRIEVED_RESULTS_RELEVANT');
    if (value >= 0.8) return t('MOST_RESULTS_RELEVANT');
    if (value >= 0.6) return t('SOME_NOISE_IN_RESULTS');
    return t('MANY_IRRELEVANT_RESULTS');
  }
  if (type === 'recall') {
    if (value === 1.0) return t('FOUND_EVERY_RELEVANT_RESULT');
    if (value >= 0.75) return t('FOUND_MOST_RELEVANT_RESULTS');
    if (value >= 0.5) return t('FOUND_HALF_RELEVANT');
    return t('MISSED_MOST_RELEVANT_RESULTS');
  }
  if (type === 'f1') {
    if (value >= 0.9) return t('EXCELLENT_OVERALL_ACCURACY');
    if (value >= 0.7) return t('GOOD_CAN_IMPROVE');
    if (value >= 0.5) return t('FAIR_NEEDS_TUNING');
    return t('POOR_MAJOR_IMPROVEMENTS_NEEDED');
  }
  return '';
};

export const getMetricDots = (value: number) => {
  const filled = Math.round(value * 4);
  return Array.from({ length: 4 }, (_, i) => i < filled);
};

export const getQueryTypeLabel = (queryType: string, t: TFunction) => {
  switch (queryType) {
    case 'initial':
      return t('INITIAL');
    case 'sub-query-1':
      return t('SUB_QUERY_1');
    case 'sub-query-2':
      return t('SUB_QUERY_2');
    case 'final':
      return t('FINAL');
    default:
      return queryType;
  }
};
